import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import AsyncSelect from 'components/AsyncSelect';
import PropTypes from 'prop-types';
import { GECKO_CONSTS, GECKO_UTILS, GeckoFields } from 'ui';
import GeckoFeatures from 'services/gecko-features';

const defaultValue = {
  label: '',
  url: '',
  answer_id: null,
  skill_id: null,
  chatgpt_query: '',
};

const SkillDisplayListItem = (props) => {
  const { value = defaultValue, onChange = () => {}, botId = null } = props;
  const [editting, setEditting] = useState(false);

  const toggleDropdown = () => {
    setEditting(!editting);
  };
  const startEditting = () => {
    setEditting(true);
  };

  const fields = () => {
    return [
      {
        label: 'Label',
        key: 'label',
        required: true,
        description: `What should the option text say?`,
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
        width: '100%',
      },
      {
        label: 'URL',
        key: 'url',
        description: `Enter a URL where you'd like the user to be taken once the option is clicked.`,
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
        width: '100%',
        disabledWhen: () =>
          value.answer_id || value.chatgpt_query || value.skill_id,
      },
      {
        label: 'Invoke Answer',
        key: 'answer_id',
        description: `Choose an Answer from your library to be invoked when this option is selected.`,
        disabledWhen: () => value.url || value.chatgpt_query || value.skill_id,
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <AsyncSelect
            selectUrl={`/bots/${botId}/answers/select`}
            getUrl={`/bots/${botId}/answers`}
            optionTransform={(answer) => ({
              label: answer.name,
              value: answer.id,
            })}
          />
        ),
        width: '100%',
      },
      {
        label: 'Invoke Skill',
        key: 'skill_id',
        description: `Choose a Skill from your library to be invoked when this options is selected.`,
        disabledWhen: () => value.url || value.answer_id || value.chatgpt_query,
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <AsyncSelect
            selectUrl={`/bots/${botId}/skills/select`}
            getUrl={`/bots/${botId}/skills`}
            optionTransform={(skill) => ({
              label: skill.name,
              value: skill.id,
            })}
          />
        ),
        width: '100%',
      },
      {
        label: 'Prompt ChatGPT',
        key: 'chatgpt_query',
        description:
          'Send a prompt to ChatGPT so an answer can be generated using your scraped website data.',
        disabledWhen: () => value.url || value.answer_id || value.skill_id,
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
        width: '100%',
        hideWhen: () => !GeckoFeatures.can('ai-engine') && !value.chatgpt_query,
      },
    ];
  };

  const changeHandler = (key, newValue) => {
    const newItem = GECKO_UTILS.setNestedValue(value, key, newValue);
    onChange(newItem);
  };
  return (
    <div className="SkillDisplayListItem" onClick={startEditting}>
      <Dropdown
        className="SkillDisplayListItem-dropdown"
        show={editting}
        onToggle={toggleDropdown}
        drop="up"
      >
        <Dropdown.Toggle as="span" className="SkillDisplayListItem-preview">
          <span>{value.label}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <GeckoFields
            fields={fields()}
            values={value}
            handler={changeHandler}
          />
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
SkillDisplayListItem.propTypes = {
  value: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    answer_id: PropTypes.number,
    skill_id: PropTypes.number,
    chatgpt_query: PropTypes.string,
  }),
  onChange: PropTypes.func,
};
export default SkillDisplayListItem;
